// src/features/agent/hooks/useGetCouponList.ts
import { useQuery} from "@tanstack/react-query";
import { App } from "antd";
import { handleError } from "api";
import { AgentsApiService } from "features/agent/api/agents-api.service";
import { CouponLogResponse } from "features/agent/types/coupon";
import { CouponQueryKeys } from "features/agent/use-cases/coupon-keys";

const { getCouponList } = AgentsApiService();
//,
  //options?: Omit<UseQueryOptions<CouponLogResponse, Error>, 'queryKey' | 'queryFn'>
export const useGetCouponList = (
  params: any
) => {
  const { message } = App.useApp();

  return useQuery<CouponLogResponse, Error>(
    CouponQueryKeys.list(params),
    ({ signal }) => getCouponList(params, { config: { signal } }),
    {
      onError: (error: any) => {
        console.error("Coupon API Error", error);
        message.error(handleError(error));
      },
      select: (data) => data,
    }
  );
};
